import { defineStore } from 'pinia'
import { store } from '../index'
import { initBaseDataApi } from '@/api/data/common'
import { useStorage } from '@/hooks/web/useStorage'

const { setStorage, removeStorage } = useStorage()

interface BaseData {
  dicOptionList: []
  provinceOptionList: []
}

export const useBaseDataStore = defineStore('baseData', {
  state: (): BaseData => {
    return {
      dicOptionList: [],
      provinceOptionList: []
    }
  },
  getters: {
    getDicOptionList(): [] {
      return this.dicOptionList
    },
    getProvinceOptionList(): [] {
      return this.provinceOptionList
    }
  },
  actions: {
    setDicOptionList(dicOptionList: []) {
      this.dicOptionList = dicOptionList
    },
    setProvinceOptionList(provinceOptionList: []) {
      this.provinceOptionList = provinceOptionList
    },
    async initBaseData() {
      const res = await initBaseDataApi().catch(() => {})
      setStorage('dicOptionList', res.data.dicOptionList)
      setStorage('provinceOptionList', res.data.provinceOptionList)
      setStorage('cityOptionList', res.data.cityOptionList)
      setStorage('areaOptionList', res.data.areaOptionList)
      setStorage('townOptionList', res.data.townOptionList)
    },
    clearBaseData() {
      removeStorage('dicOptionList')
      removeStorage('provinceOptionList')
      removeStorage('cityOptionList')
      removeStorage('areaOptionList')
      removeStorage('townOptionList')
    }
  },
  persist: true
})

export const useBaseDataStoreWithOut = () => {
  return useBaseDataStore(store)
}
